import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'
import { REVISION_ENTITY_TYPE } from '@/modules/diagnosisModule/constants/revisionEntityType'
import sampleRevisionServices from '@/api/resources/common/sampleRevisionServices'
import portionRevisionServices from '@/api/resources/common/portionRevisionServices'
import subportionRevisionServices from '@/api/resources/common/subportionRevisionServices'
import { PromiseUtils } from '@/shared/util/promise-utils'

export class ReviewHelper {
    static async mapReviewInfo(laboratoryId, entity, entityType) {
        const mappedEntity = { ...entity }
        mappedEntity.label = entity.samLabel || entity.porLabel || entity.supLabel
        mappedEntity.portionLabel = entity.porLabel

        let caseId, sampleId, portionId, subportionId
        let revision
        let mappedEntityType
        if (entityType === ENTITIES_LABORATORY.SAMPLE) {
            mappedEntityType = REVISION_ENTITY_TYPE.SAMPLE
            caseId = entity.caseStudy.casId
            sampleId = entity.id
            revision = await PromiseUtils.toCallUnique(sampleRevisionServices.getSampleUnfinishedRevision(caseId, sampleId, laboratoryId))
        } else if (entityType === ENTITIES_LABORATORY.PORTION) {
            mappedEntityType = REVISION_ENTITY_TYPE.PORTION
            caseId = entity.sample.caseStudy.casId
            sampleId = entity.sample.samId
            portionId = entity.porId
            revision = await PromiseUtils.toCallUnique(portionRevisionServices.getPortionUnfinishedRevision(caseId, sampleId, portionId, laboratoryId))
        } else if (entityType === ENTITIES_LABORATORY.SUBPORTION) {
            mappedEntityType = REVISION_ENTITY_TYPE.SUBPORTION
            caseId = entity.portion.sample.caseStudy.casId
            sampleId = entity.portion.sample.samId
            portionId = entity.portion.porId
            subportionId = entity.supId
            revision = await PromiseUtils.toCallUnique(subportionRevisionServices.getSubportionUnfinishedRevision(caseId, sampleId, portionId, subportionId, laboratoryId))
        }
        return {
            caseId,
            revision,
            entity: mappedEntity,
            entityType: mappedEntityType
        }
    }
}
